// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + chunkId + "." + {"189": "f4b389a7","32": "cc572640","652": "bec1cbcf","95": "37b5ba5c",}[chunkId] + ".js"
}